import useRenderer from '@hooks/useRenderer'
import { mobileCSS } from '@measures/responsive'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

export interface MultilineDossierMultilineProps {
  children: MultilineDossierContent
}

const StyledMultilineDossierMultiline = styled.div`
  grid-column: span 6;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  grid-gap: 20px;
  box-sizing: border-box;

  > * {
    grid-column: span 6;
    min-width: 0;
  }

  padding: 36px;
  ${mobileCSS(
    css`
      padding: 12px;
    `
  )}
`

type MultilineDossierContent = {
  kind: string[]
  content: {
    kind: string[]
    content: {
      kind: string[]
      content: {
        kind: string[]
        content: Record<string, unknown>[]
      }[]
    }[]
  }[]
}[]

type FlattenMultilineDossier = (
  content: MultilineDossierContent
) => { kind: string[] }[]

const flattenMultilineDossier: FlattenMultilineDossier = (content) => [
  ...content[0].content[0].content[0].content,
  // This is to avoid throwing an error when there is no dossier content
  ...(content[0].content[0].content[1]?.content ?? []),
]

const MultilineDossierMultiline: FunctionComponent<
  MultilineDossierMultilineProps
> = ({ children }) => {
  const Renderer = useRenderer()
  const flattenedChildren = flattenMultilineDossier(children)

  return (
    <StyledMultilineDossierMultiline>
      <Renderer>{flattenedChildren}</Renderer>
    </StyledMultilineDossierMultiline>
  )
}

export default MultilineDossierMultiline
